import { AppLayoutProvider } from '@components/AppLayout/AppLayoutContext'
import type { ThemeType } from '@components/Theme'
import { changeColorMeta } from '@components/Theme/createTheme/utils'
import useLocalStorage from '@hooks/useLocalStorage'
import { ThemeProvider as MuiThemeProvider } from '@mui/material'
import type { PropsWithChildren } from 'react'
import React, { useEffect } from 'react'

import { Baseline } from './Baseline'
import { createTheme } from './createTheme'
import { dark, light } from './themePallete'

export interface IThemeContext {
  themeType: ThemeType
  setTheme: (theme: ThemeType) => void
}
export const ThemeContext = React.createContext<IThemeContext>({
  setTheme: () => undefined,
  themeType: 'light',
})

interface ThemeProviderProps {
  defaultTheme?: ThemeType
}

const ThemeProvider: React.FC<PropsWithChildren<ThemeProviderProps>> = ({
  children,
  defaultTheme = 'light',
}) => {
  const [themeTypeName, setThemeType] = useLocalStorage('theme', defaultTheme)
  const themeType = themeTypeName as ThemeType
  const themes = {
    dark,
    light,
  }
  const theme = createTheme(themes[themeType])

  useEffect(() => {
    changeColorMeta(theme.palette.background.default)
  }, [themeType, theme.palette.background.default])

  return (
    <ThemeContext.Provider
      value={{
        setTheme: setThemeType,
        themeType,
      }}
    >
      <MuiThemeProvider theme={theme}>
        <AppLayoutProvider>
          <Baseline />
          {children}
        </AppLayoutProvider>
      </MuiThemeProvider>
    </ThemeContext.Provider>
  )
}

export default ThemeProvider
